import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import CONSTANTS from "../util/constants";
import { useDispatch, useSelector } from "react-redux";
import MovesModalComponent from "./MovesModalComp";
import DropDownComp from "./DropDownComp";
import DatePicker from "react-date-picker";
import { createGlobalStyle } from "styled-components";
import "./Tooltip.css";
import { exportPDF } from "../util/exportFile";
import Encrypt from "./../util/encrypt";
import moment from "moment";

const TableComponent = (props) => {
  const ref = React.useRef(null);
  const DatePickerWrapperStyles = createGlobalStyle`
    .date_picker.full-width {
        width: 20%;
        height: 20%
    }
    `;

  const gridRef = useRef();
  const divRef = React.createRef();

  const [rowData, setRowData] = useState();

  const [lotCheckWorkseet, setIsLotCheck] = useState(false);

  const [doorCheckWorkseet, setIsDoorCheckWorkseet] = useState(false);

  const [createReports, setIsCreateReports] = useState(false);

  const [divisionArr, setDivisionArr] = useState([]);

  const [doorDataArr, setDoorDataArr] = useState([]);

  const [lotDataArray, setLotArray] = useState([]);

  const [lotRowDataArray, setLotRowDataArray] = useState([]);

  const [doorRowDataArray, setDoorRowDataArray] = useState([]);

  const [division, setDivision] = useState({});

  const [door, setDoor] = useState({});

  const [lot, setLot] = useState({});

  const [timeFrame, setTimeFrame] = useState(null);

  const [month, setMonth] = useState("");

  const [year, setYear] = useState("");

  const [fStartDate, setStartDate] = useState("");

  const [fEndDate, setEndDate] = useState("");

  const [isShowReport, setIsShowReport] = useState(false);

  const [reportsResponse, setReportResponse] = useState({});

  const [dateSelect, onDateSelectChange] = useState(new Date());

  let rowDataDivision = useSelector((state) => state.division.getDivisionData);
  rowDataDivision = rowDataDivision.filter((data, i) => {
    return data?.is_active === true;
  });
  const rowDataDoor = useSelector((state) => state.doors.getDoorForMove);

  const rowDataDoorWorkSheet = useSelector(
    (state) => state.workSheet.getDoorCheckWorkSheet
  );

  const rowDataLot = useSelector((state) => state.lots.getLotDivisionData);

  const rowDataLotSpace = useSelector(
    (state) => state.workSheet.getLotCheckWorkSheet
  );

  const reportsResponseData = useSelector(
    (state) => state.workSheet.reportsResponse
  );

  const [loginResponse, setLoginResponse] = useState(null);
  const [pdfData, setPdfData] = useState([]);
  const [pdfDoorData, setDoorPdfData] = useState([]);

  const loggedInUserDivision = useSelector(
    (state) => state.login.loginResponse.user.division
  );

  const timeFrameArray = [
    { value: "Today", label: "Today" },
    { value: "Day", label: "Day" },
    { value: "Week", label: "Week" },
    { value: "Month", label: "Month" },
    { value: "Year", label: "Year" },
  ];

  const monthFrameArray = [
    { value: 0, label: "January" },
    { value: 1, label: "February" },
    { value: 2, label: "March" },
    { value: 3, label: "April" },
    { value: 4, label: "May" },
    ,
    { value: 5, label: "June" },
    { value: 6, label: "July" },
    { value: 7, label: "August" },
    { value: 8, label: "September" },
    { value: 9, label: "October" },
    { value: 10, label: "November" },
    { value: 11, label: "December" },
  ];

  const yearFrameArray = [
    { value: "2019", label: "2019" },
    { value: "2020", label: "2020" },
    { value: "2021", label: "2021" },
    { value: "2022", label: "2022" },
    { value: "2023", label: "2023" },
    ,
    { value: "2024", label: "2024" },
    { value: "2025", label: "2025" },
    { value: "2026", label: "2026" },
    { value: "2027", label: "2027" },
    { value: "2028", label: "2028" },
    { value: "2029", label: "2029" },
    { value: "2030", label: "2030" },
    { value: "2031", label: "2031" },
    { value: "2032", label: "2032" },
    { value: "2033", label: "2033" },
    { value: "2034", label: "2034" },
  ];

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }
  }, []);
  useEffect(() => {
    setRowData([]);

    if (rowDataDivision && rowDataDivision.length > 0) {
      var data = [];
      for (var i = 0; i < rowDataDivision.length; i++) {
        if (
          loggedInUserDivision != null &&
          loggedInUserDivision.division_id === rowDataDivision[i].division_id
        )
          data.push({
            label: rowDataDivision[i].divisionName,
            value: rowDataDivision[i].divisionName,
            division_id: rowDataDivision[i].division_id,
          });
        else if (loggedInUserDivision == null && rowDataDivision[i].is_active)
          data.push({
            label: rowDataDivision[i].divisionName,
            value: rowDataDivision[i].divisionName,
            division_id: rowDataDivision[i].division_id,
          });
      }
      setDivisionArr(data);
    }

    if (rowDataLot && rowDataLot.length > 0) {
      var data = [];
      data.push({
        label: "All Yards",
        value: "All Yards",
      });
      for (var i = 0; i < rowDataLot.length; i++) {
        data.push({
          label: rowDataLot[i].lotName,
          value: rowDataLot[i].lot_id,
        });
      }

      setLotArray(data);
    }
  }, [rowDataDivision, rowDataDoor, rowDataLot]);

  useEffect(() => {
    if (lot != "" && rowDataLotSpace && rowDataLotSpace.length > 0) {
      let data = [];
      let pdfDataTemp = [];
      let temp = [];
      for (var i = 0; i < rowDataLotSpace.length; i++) {
        let btId = rowDataLotSpace[i]?.btId ? rowDataLotSpace[i].btId : "";

        data.push({
          lotName: rowDataLotSpace[i].lotName,
          btId: btId,
          currentOccupancy:
            rowDataLotSpace[i].trailerBtId != null
              ? rowDataLotSpace[i].trailerBtId
              : "--",
          Correct: "",
          Correction: "",
        });
        temp = [
          rowDataLotSpace[i].lotName,
          rowDataLotSpace[i].btId,
          rowDataLotSpace[i].trailerBtId != null
            ? rowDataLotSpace[i].trailerBtId
            : "---",
          rowDataLotSpace[i].Correct ? "Checked" : "",
          rowDataLotSpace[i].Correction,
        ];
        pdfDataTemp.push(temp);
      }

      setPdfData(pdfDataTemp);
      setLotRowDataArray(data);
    } else {
      setLotRowDataArray([]);
    }
  }, [rowDataLotSpace, pdfData]);

  useEffect(() => {
    if (rowDataLot && rowData?.length > 0) {
      let lotTempArray = rowDataLot?.filter(
        (item) => item.division?.divisionName == division?.value
      );
      if (lotTempArray && lotTempArray.length > 0) {
        var data = [];
        data.push({
          label: "All Yards",
          value: "All Yards",
        });
        for (var i = 0; i < lotTempArray.length; i++) {
          data.push({
            label: lotTempArray[i].lotName,
            value: lotTempArray[i].lotName,
          });
        }

        setLotArray(data);
      }
    }
  }, [division != "" && lotCheckWorkseet]);

  useEffect(() => {
    if (
      rowDataDoorWorkSheet &&
      rowDataDoorWorkSheet.length > 0 &&
      rowDataDoorWorkSheet != "Failed"
    ) {
      let divisionData = rowDataDoorWorkSheet?.filter(
        (item) => item.division_id == division.division_id
      );

      if (divisionData && divisionData.length > 0) {
        let doorDataTemp = divisionData.filter(
          (item) => item.doorType == door?.value
        );

        if (door?.value == "All Doors") {
          setDoorRowDataArray(divisionData);
          let doorexportMap = [];
          divisionData.forEach((door) => {
            const temp = [
              door.doorType,
              door.number,
              door.btId ? door.btId : door.containerBtId,
              "",
              "",
            ];
            doorexportMap.push(temp);
          });
          setDoorPdfData(doorexportMap);
        } else if (doorDataTemp && doorDataTemp.length > 0) {
          setDoorRowDataArray(doorDataTemp);
          let doorexportMap = [];
          doorDataTemp.forEach((door) => {
            const temp = [
              door.doorType,
              door.number,
              door.btId ? door.btId : door.containerBtId,
              door.Correct ? "Checked" : "",
              "",
            ];
            doorexportMap.push(temp);
          });
          setDoorPdfData(doorexportMap);
        } else {
          setDoorPdfData([]);
          setDoorRowDataArray([]);
        }
      } else {
        setDoorPdfData([]);
        setDoorRowDataArray([]);
      }
    } else {
      setDoorPdfData([]);
      setDoorRowDataArray([]);
    }
  }, [door != "" && rowDataDoorWorkSheet, pdfDoorData]);

  useEffect(() => {
    if (reportsResponseData && reportsResponseData != null) {
      setReportResponse(reportsResponseData);
    }
  }, [reportsResponseData]);

  const cellImageRender = (params) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          alignContent: "center",
        }}
      >
        <input
          type="checkbox"
          value={params.data.Correct || false}
          onClick={(e) => {
            if (e.target.checked) {
              params.data.Correct = true;
            } else {
              params.data.Correct = false;
            }

            dispatch({
              type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.UPDATE_PDF_DATA,
              payload: { value: { data: params.data, index: params.rowIndex } },
            });
          }}
        />
      </div>
    );
  };

  const headers = [
    "Yard Name",
    "Space Number",
    "Current Occupant",
    "Correct",
    "Correction",
  ];
  const headersDoor = [
    "Door Type",
    "Door Number",
    "Current Occupant",
    "Correct",
    "Correction",
  ];
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Yard Name",
      field: "lotName",
      filter: true,
      resizable: true,
      flex: 1,
    },

    {
      headerName: "Space Number",
      field: "Space Number",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let btId = params.data && params.data.btId ? params.data.btId : "--";
        return btId;
      },
    },

    {
      headerName: "Current Occupant",
      field: "currentOccupancy",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let btId =
          params.data && params.data.currentOccupancy
            ? params.data.currentOccupancy
            : "--";
        return btId;
      },
    },

    {
      field: "Correct",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellImageRender,
    },

    { field: "Correction", filter: true, resizable: true, flex: 1 },
  ]);

  const locationTrailer = (locationArr, mappedLocation) => {
    return locationArr?.map((obj, index) => {
      const checkCount = mappedLocation?.filter((data) => {
        return data?.is_active && data?.name === obj?.location;
      });

      if (obj.location !== null && checkCount?.length > 0) {
        return (
          <div
            className=" col-12 col-lg-4 col-md-6 col-sm-6 mb-3"
            style={{
              backgroundColor: "white",
            }}
          >
            <p style={{ fontSize: 14, color: "black" }}>
              {"Trailers at "}
              {obj?.location?.length > 0 ? obj?.location : "Unknown"}
              {" : "}
              {obj?.count}
            </p>
          </div>
        );
      } else {
        return "";
      }
    });
  };

  function formatStartDate(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = "00" + ":" + "00" + ":" + "00";
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " " +
      strTime
    );
  }

  function formatEndDate(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var endTime = "23" + ":" + "59" + ":" + "59";
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " " +
      endTime
    );
  }

  const [columnDoorDefs, setDoorColumnDefs] = useState([
    {
      headerName: "Door Type",
      field: "doorType",
      filter: true,
      resizable: true,
      flex: 1,
    },

    {
      headerName: "Door Number",
      field: "number",
      filter: true,
      resizable: true,
      flex: 1,
    },

    {
      headerName: "Current Occupant",
      field: "currentOccupancy",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        if (params?.data?.btId || params?.data?.containerBtId)
          return params.data && params.data.btId
            ? params.data.btId
            : params.data.containerBtId;
        else return "--";
      },
    },

    {
      field: "Correct",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellImageRender,
    },
  ]);

  const dispatch = useDispatch();

  const [rowId, setRowId] = useState(0);

  const [modalShow, isModalShow] = useState(false);

  const [cellData, setCellClickData] = useState(null);

  const showModal = (isShow) => {
    isModalShow(isShow);
  };

  const paginationNumberFormatter = useCallback((params) => {
    return "[" + params.value.toLocaleString() + "]";
  }, []);

  const onGridReady = useCallback((params) => {
    dispatch({
      type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT
        .GET_DIVISIONS_MANAGEMENT_API_CALL,
    });
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage(1);
  }, []);

  const defaultColDef = useMemo(() => ({
    sortable: true,

    resizable: true,
  }));

  return (
    <div className="row">
      {modalShow ? (
        <MovesModalComponent
          title={cellData != null ? "Edit Move" : "Add Move"}
          show={showModal}
          handleClose={showModal}
          rowId={rowId}
          lotManagement={true}
          isShow={showModal}
          rowDataLot={cellData}
          setValue={(value) => {
            isModalShow(false);
            if (cellData != null) {
              setCellClickData(null);
              dispatch({
                type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                  .EDIT_LOTS_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            } else {
              dispatch({
                type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                  .ADD_LOTS_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            }
          }}
        />
      ) : null}

      <div className="col-md-12 col-sm-12 col-12">
        <div
          onClick={() => {
            setCellClickData(null);
          }}
          className="col-12 col-md-12 col-sm-12 col-lg-12"
        >
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div
              onClick={() => {
                setCellClickData(null);

                setIsLotCheck(true);

                setIsDoorCheckWorkseet(false);
                setIsCreateReports(false);

                setDivision("");
                setTimeFrame("");
                setMonth("");
                setYear("");
                setDoor("");
                setLot("");
                setDoorDataArr([]);
                setLotArray([]);

                if (rowDataDivision.length <= 0) {
                  dispatch({
                    type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT
                      .GET_DIVISIONS_MANAGEMENT_API_CALL,
                  });
                }
              }}
              className="col-12 col-md-5 col-sm-12 col-lg-3 mb-2"
              style={{ backgroundColor: "red", borderRadius: 4 }}
            >
              <label style={{ fontSize: "0.8em", color: "white" }}>
                {"Create Yard Check Worksheet"}
              </label>
            </div>

            <div
              onClick={() => {
                setCellClickData(null);
                setIsLotCheck(false);
                setIsDoorCheckWorkseet(true);
                setIsCreateReports(false);
                setDivision("");
                setDoor("");
                setLot("");
                setTimeFrame("");
                setMonth("");
                setYear("");
                setDoorDataArr([]);
                setLotArray([]);
                dispatch({
                  type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT
                    .GET_DOORS_FOR_MOVE_MANAGEMENT_API_CALL,
                });
              }}
              className="col-12 col-md-5 col-sm-12 col-lg-3 mb-2"
              style={{ backgroundColor: "blue", borderRadius: 4 }}
            >
              <label style={{ fontSize: "0.8em", color: "white" }}>
                {"Create Door Check Worksheet"}
              </label>
            </div>

            <div
              onClick={() => {
                setCellClickData(null);
                setIsLotCheck(false);
                setIsDoorCheckWorkseet(false);
                setIsCreateReports(true);
                setDivision("");
                setIsShowReport(false);
              }}
              className="col-12 col-md-5 col-sm-12 col-lg-3 mb-2"
              style={{ backgroundColor: "green", borderRadius: 4 }}
            >
              <label style={{ fontSize: "0.8em", color: "white" }}>
                {"Create Reports"}
              </label>
            </div>
          </div>
        </div>

        {lotCheckWorkseet ? (
          <div
            className="row container mt-4"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-4 col-md-4 col-sm-4 col-lg-4">
              <label
                style={{ fontSize: 16, color: "black", fontWeight: "normal" }}
              >
                {"Yard Check WorkSheet"}
              </label>
            </div>

            <div className="col-12 col-md-4 col-sm-12 col-lg-4">
              <DropDownComp
                styles={{
                  height: 35,
                  display: "flex",
                  flexDirection: "row",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  fontSize: 14,
                }}
                name={"Select Division"}
                options={divisionArr}
                onChange={(division) => {
                  setPdfData([]);
                  setDivision(division);
                  setLot("");
                  setLotArray([]);
                  dispatch({
                    type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                      .GET_LOTS_DIVISION_MANAGEMENT_API_CALL,
                    payload: { value: division.division_id },
                  });
                }}
                value={division}
              />
            </div>

            {division != null && division != "" ? (
              <div className="col-12 col-md-4 col-sm-12 col-lg-4">
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Yard"}
                  options={lotDataArray}
                  onChange={(value) => {
                    setPdfData([]);
                    let lotObj = {};
                    setLot(value);
                    if (value.value != null && value.value != "") {
                      if (value.value != "All Yards") {
                        lotObj = {
                          lot_id: value.value,
                          division_id: division.division_id,
                        };
                      } else {
                        lotObj = { division_id: division.division_id };
                      }
                      dispatch({
                        type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT
                          .GET_LOT_CHECK_WORKSHEET_API_CALL,
                        payload: { value: lotObj },
                      });
                    }
                  }}
                  value={lot}
                />
              </div>
            ) : null}
            {lotRowDataArray && lotRowDataArray?.length > 0 ? (
              loginResponse &&
              ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                loginResponse?.user?.userRoles[0]?.priority) ||
                (loginResponse?.user?.userRoles[0]?.user_role_name ==
                  CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                  loginResponse?.user?.userRoles[0]?.priority)) ? (
                <button
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                    width: "10%",
                    fontSize: 14,
                    textAlign: "center",
                    backgroundColor: "lightBlue",
                    borderRadius: 8,
                    padding: 6,
                  }}
                  onClick={() => exportPDF("YardReport.pdf", headers, pdfData)}
                >
                  EXPORT
                </button>
              ) : null
            ) : null}
          </div>
        ) : null}

        {doorCheckWorkseet ? (
          <div
            className="row container mt-4"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-4 col-md-4 col-sm-4 col-lg-4">
              <label
                style={{ fontSize: 16, color: "black", fontWeight: "normal" }}
              >
                {"Door Check WorkSheet"}
              </label>
            </div>

            <div className="col-12 col-md-4 col-sm-12 col-lg-4">
              <DropDownComp
                styles={{
                  height: 35,
                  display: "flex",
                  flexDirection: "row",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  fontSize: 14,
                }}
                name={"Select Division"}
                options={divisionArr}
                onChange={(value) => {
                  setDoorPdfData([]);
                  setDivision(value);
                  setDoorDataArr([]);
                  setDoor("");
                  var data = [
                    {
                      label: "All Doors",
                      value: "All Doors",
                    },
                    { label: "Receiving", value: "Receiving" },
                    { label: "Shipping", value: "Shipping" },
                    { label: "Supply", value: "Supply" },
                  ];

                  setDoorDataArr(data);
                }}
                value={division}
              />
            </div>

            {division != null && division != "" ? (
              <div className="col-12 col-md-4 col-sm-12 col-lg-4">
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Door"}
                  options={doorDataArr}
                  onChange={(value) => {
                    setDoorPdfData([]);
                    setDoor(value);
                    dispatch({
                      type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT
                        .GET_DOOR_CHECK_WORKSHEET_API_CALL,
                    });
                  }}
                  value={door}
                />
              </div>
            ) : null}
            {doorDataArr && doorDataArr?.length > 0 ? (
              <button
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  alignContent: "flex-end",
                  width: "10%",
                  fontSize: 14,
                  textAlign: "center",
                  backgroundColor: "lightBlue",
                  borderRadius: 8,
                  padding: 6,
                }}
                onClick={() =>
                  exportPDF("DoorReport.pdf", headersDoor, pdfDoorData)
                }
              >
                EXPORT
              </button>
            ) : null}
          </div>
        ) : null}

        {doorCheckWorkseet && door != "" ? (
          <div
            className="col-md-12 col-sm-12 row-10 ag-theme-alpine mt-4"
            style={{
              height: window.innerWidth < 1200 ? "90vh" : "70vh",
              width: "80vw",
              margin: "auto",
            }}
          >
            <label
              style={{ fontSize: 16, color: "black", fontWeight: "normal" }}
            >
              {" Door Check WorkSheet"}
            </label>

            <AgGridReact
              suppressColumnVirtualisation={true}
              defaultColDef={defaultColDef}
              animateRows={true}
              rowData={doorRowDataArray}
              pagination={false}
              paginationAutoPageSize={false}
              paginationPageSize={10}
              paginateChildRows={false}
              enableRangeSelection={false}
              suppressRowClickSelection={false}
              groupSelectsChildren={false}
              rowSelection={"multiple"}
              rowGroupPanelShow={"always"}
              pivotPanelShow={"always"}
              columnDefs={columnDoorDefs}
              paginationNumberFormatter={paginationNumberFormatter}
              onGridReady={onGridReady}
              onFirstDataRendered={onFirstDataRendered}
            ></AgGridReact>
          </div>
        ) : createReports ? (
          <div
            className="col-md-12 col-sm-12 row-10 ag-theme-alpine mt-4"
            style={{
              height: window.innerWidth < 1200 ? "90vh" : "70vh",
              width: "80vw",
              margin: "auto",
            }}
          >
            <div className=" col-4 collg-12 col-md-12 col-sm-12 ">
              <div
                className="row container mt-4"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "space-between",
                }}
              >
                <div className="col-4 col-md-4 col-sm-4 col-lg-4">
                  <DropDownComp
                    styles={{
                      height: 35,
                      display: "flex",
                      flexDirection: "row",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      fontSize: 14,
                    }}
                    name={"Select Division"}
                    options={divisionArr}
                    onChange={(division) => {
                      setIsShowReport(false);
                      setDivision(division);
                      setTimeFrame("");
                      setLot("");
                      setLotArray([]);
                      dispatch({
                        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                          .GET_LOTS_DIVISION_MANAGEMENT_API_CALL,
                        payload: { value: division.division_id },
                      });
                    }}
                    value={division}
                  />
                </div>
                <div className=" col-4 col-md-4 col-sm-4 col-lg-4" />
                <div className=" col-4 col-md-4 col-sm-4 col-lg-4" />
              </div>

              <div
                className="row container mt-4"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "space-between",
                }}
              >
                {division?.value != null &&
                division?.value != "" &&
                division?.value != undefined ? (
                  <div className="col-4 col-md-4 col-sm-4 col-lg-4">
                    <DropDownComp
                      styles={{
                        height: 35,
                        display: "flex",
                        flexDirection: "row",
                        borderColor: "hsl(0, 0%, 50%)",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        fontSize: 14,
                      }}
                      name={"Select Time Frame"}
                      options={timeFrameArray}
                      onChange={(timeFrame) => {
                        if (
                          timeFrame != "" &&
                          timeFrame != null &&
                          timeFrame.value == "Today"
                        ) {
                          setIsShowReport(true);
                        } else {
                          setIsShowReport(false);
                        }
                        setTimeFrame(timeFrame);
                        setMonth("");
                        setYear("");
                        onDateSelectChange("");
                        if (timeFrame?.value == "Today") {
                          onDateSelectChange(new Date());

                          let date = new Date();
                          // let fDate = formatStartDate(date);
                          // let fEndDate = formatEndDate(date);
                          let fDate = moment(formatStartDate(date)).format();
                          let fEndDate = moment(formatEndDate(date)).format();
                          let obj = {
                            fromDate: fDate,
                            toDate: fEndDate,
                            division_id: division.division_id,
                          };
                          dispatch({
                            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT
                              .CREATE_REPORTS_API_CALL,
                            payload: { value: obj },
                          });
                        }
                      }}
                      value={timeFrame}
                    />
                  </div>
                ) : null}

                {timeFrame?.value == "Day" || timeFrame?.value == "Week" ? (
                  <div className="col-4 col-md-4 col-sm-4 col-lg-4">
                    <DatePicker
                      styles={{
                        backgroundColor: "white",
                        height: "100vh",
                        width: "80vw",
                      }}
                      className="custumDatePicker"
                      onChange={(value) => {
                        onDateSelectChange(value);
                        if (
                          value == "" ||
                          value == null ||
                          value == undefined
                        ) {
                          setIsShowReport(false);
                        } else {
                          if (timeFrame?.value == "Week") {
                            setIsShowReport(true);

                            var dt = value; //current date of week
                            var currentWeekDay = dt.getDay();
                            var lessDays =
                              currentWeekDay == 0 ? 6 : currentWeekDay - 1;
                            var wkStart = new Date(
                              new Date(dt).setDate(dt.getDate() - lessDays)
                            );
                            var wkEnd = new Date(
                              new Date(wkStart).setDate(wkStart.getDate() + 6)
                            );
                            setStartDate(
                              wkStart.getFullYear() +
                                "-" +
                                (wkStart.getMonth() + 1) +
                                "-" +
                                wkStart.getDate()
                            );
                            setEndDate(
                              wkEnd.getFullYear() +
                                "-" +
                                (wkEnd.getMonth() + 1) +
                                "-" +
                                wkEnd.getDate()
                            );
                            // let fDate = formatStartDate(wkStart);
                            // let fEndDate = formatEndDate(wkEnd);
                            let fDate = moment(
                              formatStartDate(wkStart)
                            ).format();
                            let fEndDate = moment(
                              formatEndDate(wkEnd)
                            ).format();
                            let obj = {
                              fromDate: fDate,
                              toDate: fEndDate,
                              division_id: division.division_id,
                            };
                            dispatch({
                              type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT
                                .CREATE_REPORTS_API_CALL,
                              payload: { value: obj },
                            });
                          } else {
                            setIsShowReport(true);
                            let date = value;
                            // let fDate = formatStartDate(date);
                            // let fEndDate = formatEndDate(date);
                            let fDate = moment(formatStartDate(date)).format();
                            let fEndDate = moment(formatEndDate(date)).format();
                            let obj = {
                              fromDate: fDate,
                              toDate: fEndDate,
                              division_id: division.division_id,
                            };
                            dispatch({
                              type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT
                                .CREATE_REPORTS_API_CALL,
                              payload: { value: obj },
                            });
                          }
                        }
                      }}
                      value={dateSelect}
                    />
                    <DatePickerWrapperStyles />
                  </div>
                ) : null}
                {timeFrame?.value == "Month" ? (
                  <div className="col-4 col-md-4 col-sm-4 col-lg-4">
                    <DropDownComp
                      styles={{
                        height: 35,
                        display: "flex",
                        flexDirection: "row",

                        borderColor: "hsl(0, 0%, 50%)",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        fontSize: 14,
                      }}
                      name={"Select Month"}
                      options={monthFrameArray}
                      onChange={(month) => {
                        if (
                          month == "" ||
                          month == null ||
                          month == undefined
                        ) {
                          setIsShowReport(false);
                        }

                        setMonth(month);
                        setYear("");
                      }}
                      value={month}
                    />
                  </div>
                ) : null}
                {timeFrame?.value == "Month" || timeFrame?.value == "Year" ? (
                  <div className="col-4 col-md-4 col-sm-4 col-lg-4">
                    <DropDownComp
                      styles={{
                        height: 35,
                        display: "flex",
                        flexDirection: "row",

                        borderColor: "hsl(0, 0%, 50%)",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        fontSize: 14,
                      }}
                      name={"Select Year "}
                      options={yearFrameArray}
                      onChange={(year) => {
                        if (year == "" || year == null || year == undefined) {
                          setIsShowReport(false);
                        } else {
                          setIsShowReport(true);
                        }

                        setYear(year);

                        if (timeFrame.value == "Month" && month != "") {
                          var firstDay = new Date(year.value, month.value, 1);
                          var lastDay = new Date(
                            year.value,
                            month.value + 1,
                            0
                          );
                          // let fDate = formatStartDate(firstDay);
                          // let fEndDate = formatEndDate(lastDay);
                          let fDate = moment(
                            formatStartDate(firstDay)
                          ).format();
                          let fEndDate = moment(
                            formatEndDate(lastDay)
                          ).format();
                          let obj = {
                            fromDate: fDate,
                            toDate: fEndDate,
                            division_id: division.division_id,
                          };
                          dispatch({
                            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT
                              .CREATE_REPORTS_API_CALL,
                            payload: { value: obj },
                          });
                        } else {
                          var firstDay = new Date(year.value, 0, 31);
                          var lastDay = new Date(year.value, 11, 31);
                          // let fDate = formatStartDate(firstDay);
                          // let fEndDate = formatEndDate(lastDay);
                          let fDate = moment(
                            formatStartDate(firstDay)
                          ).format();
                          let fEndDate = moment(
                            formatEndDate(lastDay)
                          ).format();
                          let obj = {
                            fromDate: fDate,
                            toDate: fEndDate,
                            division_id: division.division_id,
                          };
                          dispatch({
                            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT
                              .CREATE_REPORTS_API_CALL,
                            payload: { value: obj },
                          });
                        }
                      }}
                      value={year}
                    />
                  </div>
                ) : null}
              </div>

              {isShowReport ? (
                <div
                  className="col-8 collg-12 col-md-12 col-sm-12 "
                  style={{
                    height: "40vh",
                  }}
                >
                  <div
                    className="col-12 collg-12 col-md-12 col-sm-12 "
                    style={{
                      display: "flex",
                      height: "6vh",
                      backgroundColor: "#0dcaf0",
                      border: "2px solid rgba(0, 0, 0, 0.1)",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <label style={{ fontSize: 16, color: "white" }}>
                      {division?.value}
                      {" Division "}{" "}
                      {(timeFrame?.value != null &&
                      timeFrame?.value != undefined &&
                      timeFrame?.value != ""
                        ? timeFrame?.value
                        : "") + " :"}{" "}
                      {timeFrame?.value == "Day" || timeFrame?.value == "Today"
                        ? new Date(dateSelect).getMonth() +
                          1 +
                          "/" +
                          new Date(dateSelect).getDate() +
                          "/" +
                          new Date(dateSelect).getFullYear()
                        : timeFrame?.value == "Week"
                        ? fStartDate + "    " + "   -   " + "    " + fEndDate
                        : timeFrame?.value == "Month"
                        ? month?.label +
                          (year?.value != undefined ? "-" + year?.value : "")
                        : timeFrame?.value == "Year"
                        ? year?.value
                        : "----"}
                    </label>
                  </div>

                  <div
                    className="col-12 collg-12 col-md-12 col-sm-12 "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "white",
                      border: "2px solid rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      className="row col-12 collg-12 col-md-12 col-sm-12 "
                      style={{
                        display: "flex",
                        backgroundColor: "white",
                        borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="col-12 col-lg-12 col-md-12 col-sm-12 mb-2 mt-2"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <h5 style={{ fontSize: 16, color: "black" }}>
                          {"Moves "}
                        </h5>
                      </div>

                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Trailer Moves: "}
                          {reportsResponse?.moves?.trailerStat[0]?.movesCount}
                        </p>
                      </div>

                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Completed: "}
                          {
                            reportsResponse?.moves?.trailerStat[0]
                              ?.completedCount
                          }
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"% Completed: "}
                          {isNaN(
                            reportsResponse?.moves?.trailerStat[0]
                              ?.completedCount /
                              reportsResponse?.moves?.trailerStat[0]?.movesCount
                          ) * 100
                            ? 0
                            : (reportsResponse?.moves?.trailerStat[0]
                                ?.completedCount /
                                reportsResponse?.moves?.trailerStat[0]
                                  ?.movesCount) *
                              100}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Avg. Duration minutes: "}
                          {reportsResponse?.moves?.trailerStat[0]?.avgVal || 0}
                        </p>
                      </div>

                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Outside Carrier Moves: "}
                          {reportsResponse?.moves?.offsideCarrierStat[0]
                            ?.movesCount || 0}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Completed: "}
                          {reportsResponse?.moves?.offsideCarrierStat[0]
                            ?.completedCount || 0}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"% Completed: "}
                          {isNaN(
                            reportsResponse?.moves?.offsideCarrierStat[0]
                              ?.completedCount /
                              reportsResponse?.moves?.offsideCarrierStat[0]
                                ?.movesCount
                          ) * 100
                            ? 0
                            : (reportsResponse?.moves?.offsideCarrierStat[0]
                                ?.completedCount /
                                reportsResponse?.moves?.offsideCarrierStat[0]
                                  ?.movesCount) *
                              100}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Avg. Duration minutes: "}
                          {reportsResponse?.moves?.offsideCarrierStat[0]
                            ?.avgVal || 0}
                        </p>
                      </div>

                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"OffSite Moves: "}
                          {reportsResponse?.moves?.offsiteMoves[0]?.movesCount}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Completed: "}
                          {isNaN(
                            reportsResponse?.moves?.offsiteMoves[0]
                              ?.completedCount
                          )
                            ? 0
                            : reportsResponse?.moves?.offsiteMoves[0]
                                ?.completedCount}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"% Completed: "}
                          {isNaN(
                            (reportsResponse?.moves?.offsiteMoves[0]
                              ?.completedCount /
                              reportsResponse?.moves?.offsiteMoves[0]
                                ?.movesCount) *
                              100
                          )
                            ? 0
                            : (reportsResponse?.moves?.offsiteMoves[0]
                                ?.completedCount /
                                reportsResponse?.moves?.offsiteMoves[0]
                                  ?.movesCount) *
                              100}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-3 col-md-3 col-sm-3 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Avg. Duration minutes: "}
                          {reportsResponse?.moves?.offsiteMoves[0]?.avgVal || 0}
                        </p>
                      </div>
                    </div>

                    <div
                      className="row col-12 collg-12 col-md-12 col-sm-12 "
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        className=" col-12 col-lg-12 col-md-12 col-sm-12 mb-2 mt-2"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <h5 style={{ fontSize: 16, color: "black" }}>
                          {"Canceled Moves"}
                        </h5>
                      </div>

                      <div
                        className=" col-12 col-lg-4 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Offside Carrier, Moves: "}
                          {reportsResponse?.canceledMoves
                            ?.offsideCarrierStatCancld[0]?.movesCount || "--"}
                        </p>
                      </div>
                      {/* <div
                        className=" col-12 col-lg-4 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Offside Carrier, Canalled : "}
                          {reportsResponse?.canceledMoves
                            ?.offsideCarrierStatCancld[0]?.CanclledCount ||
                            "--"}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-4 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Offside Carrier, Avg : "}
                          {reportsResponse?.canceledMoves
                            ?.offsideCarrierStatCancld[0]?.avgVal || "--"}
                        </p>
                      </div> */}
                      <div
                        className=" col-12 col-lg-4 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Offsite Moves Cancelled, Moves: "}
                          {reportsResponse?.canceledMoves?.offsiteMovesCancld[0]
                            ?.movesCount || "--"}
                        </p>
                      </div>
                      {/* <div
                        className=" col-12 col-lg-4 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Offsite Moves Cancelled, Canalled : "}
                          {reportsResponse?.canceledMoves?.offsiteMovesCancld[0]
                            ?.CanclledCount || "--"}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-4 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Offsite Moves Cancelled, Avg : "}
                          {reportsResponse?.canceledMoves?.offsiteMovesCancld[0]
                            ?.avgVal || "--"}
                        </p>
                      </div> */}
                      <div
                        className=" col-12 col-lg-4 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Trailer, Moves: "}
                          {reportsResponse?.canceledMoves?.trailerStatCancld[0]
                            ?.movesCount || "--"}
                        </p>
                      </div>
                      {/* <div
                        className=" col-12 col-lg-4 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Trailer, Canalled : "}
                          {reportsResponse?.canceledMoves?.trailerStatCancld[0]
                            ?.CanclledCount || "--"}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-4 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"Trailer, Avg : "}
                          {reportsResponse?.canceledMoves?.trailerStatCancld[0]
                            ?.avgVal || "--"}
                        </p>
                      </div> */}
                    </div>
                    <div
                      className="row col-12 collg-12 col-md-12 col-sm-12 "
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        className=" col-12 col-lg-12 col-md-12 col-sm-12 mb-2 mt-2"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <h5 style={{ fontSize: 16, color: "black" }}>
                          {"Departments"}
                        </h5>
                      </div>

                      <div
                        className=" row"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        {reportsResponse?.departmentData?.movesByDepartment?.map(
                          (mData, i) => {
                            if (
                              mData?.department === null ||
                              mData?.department === ""
                            ) {
                              return null;
                            }
                            return (
                              <div
                                className=" col-12 col-lg-6 col-md-6 col-sm-6 mb-3"
                                style={{
                                  backgroundColor: "white",
                                }}
                              >
                                <p style={{ fontSize: 14, color: "black" }}>
                                  {`Moves, Total ${mData?.department}: `}
                                  {mData?.moveCount || "--"}
                                </p>
                              </div>
                            );
                          }
                        )}
                        {/* <p style={{ fontSize: 14, color: "black" }}>
                          {"Moves, Total SOCKS: "}
                          {reportsResponse?.departmentData?.movesByDepartment[0]
                            ?.moveCount || "--"}
                        </p> */}
                      </div>
                      <div
                        className=" row"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        {/* <p style={{ fontSize: 14, color: "black" }}>
                          {"Moves, Total BPW: "}
                          {reportsResponse?.departmentData?.movesByDepartment[1]
                            ?.moveCount || 0}
                        </p> */}
                        {reportsResponse?.departmentData?.OffsiteByDepartment?.map(
                          (mData, i) => {
                            if (
                              mData?.department === null ||
                              mData?.department === ""
                            ) {
                              return null;
                            }
                            return (
                              <div
                                className=" col-12 col-lg-6 col-md-6 col-sm-6 mb-3"
                                style={{
                                  backgroundColor: "white",
                                }}
                              >
                                <p style={{ fontSize: 14, color: "black" }}>
                                  {`OffSite Moves, Total ${mData?.department}: `}
                                  {mData?.moveCount || "--"}
                                </p>
                              </div>
                            );
                          }
                        )}
                      </div>
                      {/* <div
                        className=" col-12 col-lg-6 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"OffSite Moves, Total SOCKS: "}
                          {reportsResponse?.departmentData
                            ?.OffsiteByDepartment[0]?.moveCount || 0}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-6 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"OffSite Moves, Total BPW: "}
                          {reportsResponse?.departmentData
                            ?.OffsiteByDepartment[0]?.moveCount || 0}
                        </p>
                      </div> */}
                    </div>

                    <div
                      className="row col-12 collg-12 col-md-12 col-sm-12 "
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        className=" col-12 col-lg-12 col-md-12 col-sm-12 mb-2 mt-2"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <h5 style={{ fontSize: 16, color: "black" }}>
                          {"Trucks"}
                        </h5>
                      </div>

                      <div
                        className=" col-12 col-lg-6 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {" Moves, Shuttles: "}
                          {reportsResponse?.truckData?.movesByTruckType[0]
                            ?.moveCount || 0}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-6 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {" Moves, Switchers: "}
                          {reportsResponse?.truckData?.movesByTruckType[1]
                            ?.moveCount || 0}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-6 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"OffSite Moves, Shuttles: "}
                          {reportsResponse?.truckData?.OffsiteByTruckType[0]
                            ?.moveCount || 0}
                        </p>
                      </div>
                      <div
                        className=" col-12 col-lg-6 col-md-6 col-sm-6 mb-3"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <p style={{ fontSize: 14, color: "black" }}>
                          {"OffSite Moves, Switchers: "}
                          {reportsResponse?.truckData?.OffsiteByTruckType[1]
                            ?.moveCount || 0}
                        </p>
                      </div>
                    </div>

                    <div
                      className="row col-12 collg-12 col-md-12 col-sm-12 "
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        className=" col-12 col-lg-12 col-md-12 col-sm-12 mb-2 mt-2"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <h5 style={{ fontSize: 16, color: "black" }}>
                          {"Trailers"}
                        </h5>
                      </div>
                      {locationTrailer(
                        reportsResponse?.updatedTrailerDataByLocatiton
                          ?.updatedTrailerDataByLocatiton,
                        reportsResponse?.mappedOffsite?.locations
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ) : lotCheckWorkseet && lot != "" ? (
          <div
            ref={divRef}
            className="col-md-12 col-sm-12 row-10 ag-theme-alpine mt-4"
            style={{
              height: window.innerWidth < 1200 ? "90vh" : "70vh",
              width: "80vw",
              margin: "auto",
            }}
          >
            <AgGridReact
              ref={gridRef}
              suppressColumnVirtualisation={true}
              defaultColDef={defaultColDef}
              animateRows={true}
              rowData={lotRowDataArray}
              pagination={false}
              paginationAutoPageSize={false}
              paginationPageSize={10}
              paginateChildRows={false}
              enableRangeSelection={false}
              suppressRowClickSelection={false}
              groupSelectsChildren={false}
              rowSelection={"multiple"}
              rowGroupPanelShow={"always"}
              pivotPanelShow={"always"}
              columnDefs={columnDefs}
              paginationNumberFormatter={paginationNumberFormatter}
              onGridReady={onGridReady}
              onFirstDataRendered={onFirstDataRendered}
            ></AgGridReact>
          </div>
        ) : (
          <div
            className="col-md-12 col-sm-12 row-10 ag-theme-alpine mt-4"
            style={{
              height: window.innerWidth < 1200 ? "90vh" : "70vh",
              width: "80vw",
              margin: "auto",
            }}
          />
        )}
      </div>
    </div>
  );
};
export default TableComponent;
